import { TPartnerState } from './domain';

export const DEFAULT_PARTNER_STATE: TPartnerState = {
    id: '',
    siteurl: '',
    title: '',
    phone: '',
    email: '',
    address: '',
    website: '',
    social_media: {
        google: '',
        twitter: '',
        facebook: '',
        youtube: '',
        instagram: '',
        yelp: '',
        tripadvisor: '',
    },
    status: '',
    active: false,
    maintenance: false,
    stripe_on: false,
    stripe_acct_id: '',
    stripe_public_key: '',
    anet_transaction_key: '',
    anet_api_login_id: '',
    anet_public_key: '',
    trip_order: [],
    timezone: '',
    gratuity_trips: [],
    suggested_gratuity: [],
    enable_gratuity_online: false,
    enable_hold_online: false,
    inter_payments: false,
    deposit_type: false,
    relative_deposit: '',
    absolute_deposit: '',
    enable_billing_address: false,
    enable_emergency_contact: false,
    show_reviews: false,
    google_rating: false,
    use_categories: false,
    isLightframePage: false,
    texts: {},
    ga4_id: '',
    fb_pixel_id: '',
};
